import FetchBase from '../Api/FetchBase'
import { observable, action } from 'mobx'
import {
  DEFAULT_PAGE_START,
  DEFAULT_PER_PAGE_RECORD,
  API_ENDPOINTS,
  FILE_SOURCE_STORE_TYPE,
  TEXTS,
  ERROR_CODE,
} from '../Utils/constants'
import { generateFormData, zeroWrapper } from '../Utils/helpers'
import { getUtcUnixDate } from '../Utils/rules'

export default class ProjectsStore extends FetchBase {
  @observable isReportReadyToSend = false
  @observable isUserAssigned = false
  @observable isAssignedUser = false

  @observable totalProjects = 0
  @observable dashboardProjectStatus = undefined
  @observable projects = []
  @observable projectsLoader = false
  @observable projectsSearchText = ''
  @observable projectsPageNo = DEFAULT_PAGE_START
  @observable projectsPageLimit = DEFAULT_PER_PAGE_RECORD

  @observable projectFiltersGetLoader = false
  @observable projectFiltersCustomers = []
  @observable projectsFiltersOnSiteLead = []
  @observable projectFiltersStatus = []
  @observable projectFiltersOwnersMediacentric = []
  @observable projectFiltersOwnersCustomers = []

  @observable pfAllFilters = {}
  @observable pfSelectedDateChoice = undefined

  @observable billSettings = []
  @observable projectStatues = []
  @observable projectTags = []
  @observable projectTaskStatusCount = {}
  @observable projectTaskStatusCountByGroup = {}

  @observable specificProject = {}
  @observable onSitePermission = {}
  @observable projectByIdError = false
  @observable projectByIdErrorMessage = TEXTS?.SOME_THING_WRONG

  @observable sourceStorageType = undefined

  @observable projectFoldersDropdownLoader = false
  @observable projectFoldersDropdownList = []
  @observable projectFoldersSearchText = ''
  @observable projectFoldersLoader = false
  @observable projectFoldersCurrentPage = DEFAULT_PAGE_START
  @observable projectFoldersList = []
  @observable isUserAssignedInProjectFolder = false
  @observable projectFoldersTotal = 0
  @observable addProjectFolderLoader = false

  @observable moveAttachmentbyIdLoader = false
  @observable projectAttachmentsSearchText = ''
  @observable projectAttachments = []
  @observable projectAttachmentsLoader = false
  @observable projectAttachmentsTotal = 0
  @observable projectAttachmentsCurrentPage = DEFAULT_PAGE_START
  @observable projectAttachmentsFilter = {}

  @observable projectDailyReportAttachmentsFilter = {}
  @observable projectDailyReportAttachmentsDateChoice = undefined
  @observable projectDailyReportAttachmentsSearchText = ''
  @observable projectDailyReportAttachmentsCurrentPage = DEFAULT_PAGE_START
  @observable projectDailyReportAttachmentsLoader = false
  @observable projectDailyReportAttachments = []
  @observable projectDailyReportAttachmentsTotal = 0
  @observable sendProjectDailyReportAttachmentLoader = false
  @observable projectDailyReportError = false
  @observable projectDailyReportErrorMessage = TEXTS?.SOME_THING_WRONG

  @observable addProjectAttachmentLoader = false

  @observable projectFeedback = []
  @observable projectFeedbackLoader = false
  @observable projectFeedbackSaveLoader = false

  @observable ordering = undefined
  @observable orderingBy = undefined

  @observable allProjectsForDropdown = []
  @observable allProjectsForDropdownLoader = false

  @observable draftProjectsLoader = false
  @observable draftProjectsPageNo = DEFAULT_PAGE_START
  @observable draftProjectsDateChoice = undefined
  @observable draftProjectsSearchText = ''
  @observable draftProjectsTotal = 0
  @observable orderingDraft = undefined
  @observable orderingDraftBy = undefined
  @observable draftProjectsFilters = {}
  @observable draftProjects = []

  @observable completedProjectsLoader = false
  @observable completedProjectsPageNo = DEFAULT_PAGE_START
  @observable completedProjectsDateChoice = undefined
  @observable completedProjectsSearchText = ''
  @observable completedProjectsTotal = 0
  @observable completedProjectsFilters = {}
  @observable completedProjects = []

  @observable cancelledProjectsLoader = false
  @observable cancelledProjectsPageNo = DEFAULT_PAGE_START
  @observable cancelledProjectsDateChoice = undefined
  @observable cancelledProjectsSearchText = ''
  @observable cancelledProjectsTotal = 0
  @observable cancelledProjectsFilters = {}
  @observable cancelledProjects = []

  @observable dashboardProjectsLoader = false
  @observable dashboardProjectsPageNo = DEFAULT_PAGE_START
  @observable dashboardProjectsDateChoice = undefined
  @observable dashboardProjectsSearchText = ''
  @observable dashboardProjectsTotal = 0
  @observable dashboardProjectsByMonth = {}
  @observable dashboardProjectsFilters = {}
  @observable dashboardProjects = []

  @observable projectResourceAllocations = {}
  @observable projectResourceAllocationsLoader = false

  @observable projectInstallationImages = []
  @observable projectInstallationImagesTotal = 0
  @observable projectInstallationImagesLoader = false
  @observable projectActionItemInstallationImages = []
  @observable projectActionItemInstallationImagesTotal = 0
  @observable projectActionItemInstallationImagesLoader = false

  @observable projectShortDetails = {}

  @observable projectStatusLoader = false

  @observable setCheckSpaceBulk = []
  @observable setCheckeFileList = []
  @observable isCheckAll = false
  @observable isBulkSpaceSelect = false
  @observable isIndeterminate = false

  @observable importProjects = []
  @observable importProjectsFailures = []
  @observable importProjectFromFileLoader = false
  @observable downloadSnapshotReportLoader = false

  @observable exportAllLoader = false

  @observable isCustomerFolderFlag = false
  @action.bound
  setOrdering = (value = undefined) => {
    this.ordering = value
  }

  @action.bound
  setOrderingBy = (value = undefined) => {
    if (value === 'projectname') {
      value = 'name'
    }
    this.orderingBy = value
  }

  @action.bound
  setReportReadyToSend = async (flag = false, id = undefined) => {
    this.isReportReadyToSend = flag
    try {
      let response = await this.post(API_ENDPOINTS.UPDATE_SEND_REPORT, {
        id,
        sendReport: flag,
      })
      if (response.status) {
        return [response.status, response.data]
      } else {
        return [false, undefined]
      }
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  getReportReadyToSend = async (flag = false) => {
    this.isReportReadyToSend = flag
  }

  @action.bound
  setFilters = (value = {}) => {
    this.pfAllFilters = value
  }

  @action.bound
  setSelectedDateChoice = (value) => {
    this.pfSelectedDateChoice = value
  }

  @action.bound
  setProjectFiltersGetLoader = (value = false) => {
    this.setProjectFiltersGetLoader = value
  }

  @action.bound
  setProjectPageNo = (value = DEFAULT_PAGE_START) => {
    this.projectsPageNo = value
  }

  @action.bound
  setProjectsSearchText = (value = '') => {
    this.projectsSearchText = value
  }

  @action.bound
  setSelectedCustomerForProjects = (value = undefined) => {
    this.projectFiltersSelectedCustomer = value
  }

  getFilterObjectForProjects = () => {
    let options = {}
    let keys = Object.keys(this.pfAllFilters || {})
    for (let filter of keys) {
      if (this.pfAllFilters[filter]) {
        options[filter] = this.pfAllFilters[filter]
      }
    }
    if (this.pfSelectedDateChoice) {
      let dateFilter = getUtcUnixDate(this.pfSelectedDateChoice, {
        start: options['startDate'],
        end: options['endDate'],
      })
      options['startDate'] = dateFilter.start
      options['endDate'] = dateFilter.end
    } else {
      delete options['startDate']
      delete options['endDate']
    }

    delete options['dateChoice']

    if (this.ordering) {
      options['ordering'] = this.ordering
      options['orderBy'] = this.orderingBy
    }
    return options
  }

  @action.bound
  getAllProjectsExportData = async ({ exportFileType = 'csv' } = {}) => {
    try {
      let filters = this.getFilterObjectForProjects()

      let options = { ...filters }
      this.projectsSearchText && (options['search'] = this.projectsSearchText)
      options['exportFileType'] = exportFileType
      options['isDraft'] = false
      options['isDeleted'] = false
      if (!options?.projectStatusId || !options?.projectStatusId?.length > 0) {
        options['projectStatusId'] = [1, 2, 3]
      }
      let response = await this.post(API_ENDPOINTS.EXPORT_PROJECTS, options)
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  deactivateProject = async (id) => {
    try {
      let response = await this.post(API_ENDPOINTS.DACTIVATE_PROJECT, {
        projectId: id,
      })
      if (response.status) {
        return [true, undefined]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  getAllProjects = async () => {
    try {
      this.projectsLoader = true
      let filters = this.getFilterObjectForProjects()
      let options = { ...filters }
      this.projectsSearchText && (options['search'] = this.projectsSearchText)
      this.projectsPageNo &&
        (options['pageNo'] = Math.max(this.projectsPageNo - 1, 0))
      options['isDraft'] = false
      options['isDeleted'] = false
      if (!options?.projectStatusId || !options?.projectStatusId?.length > 0) {
        options['projectStatusId'] = [1, 2, 3]
      }

      let response = await this.post(API_ENDPOINTS.GET_ALL_PROJECTS, options)

      if (response.status) {
        this.projects = response.data.projects || []
        this.totalProjects = response.data.total || 0
        return true
      } else {
        this.projects = []
        return false
      }
    } catch (err) {
      console.log(err, 131)
      this.projects = []
      return false
    } finally {
      this.projectsLoader = false
    }
  }

  @action.bound
  getAllOwners = async () => {
    let results = await Promise.all(
      this.getMediacentricOwnerForFilter(),
      this.getCustomerOwnerForFilter()
    )
    return results.reduce((c, ac) => c && ac, true)
  }

  @action.bound
  getCustomersForFilter = async (signal) => {
    try {
      let response = await this.get(API_ENDPOINTS.CUSTOMER_DROPDOWN, {}, signal)
      if (response.status) {
        this.projectFiltersCustomers = response.data
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      this.projectFiltersCustomers = []
      return [false, undefined]
    }
  }

  @action.bound
  getOnSiteLeadForFilter = async (signal) => {
    try {
      let response = await this.post(
        API_ENDPOINTS.GET_DROPDOWN_ONSITE_LEAD,
        {},
        signal
      )
      if (response.status) {
        this.projectsFiltersOnSiteLead = response.data.onSiteLeads
        return [true, response.data.onSiteLeads]
      }
      return [false, undefined]
    } catch (err) {
      this.projectsFiltersOnSiteLead = []
      return [false, undefined]
    }
  }

  @action.bound
  getProjectStatusForFilter = async () => {
    try {
      let response = await this.get(API_ENDPOINTS.GET_ALL_TASK_STATUSES)
      if (response.status) {
        this.projectFiltersStatus = response.data
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      this.projectFiltersStatus = []
      return [false, undefined]
    }
  }

  @action.bound
  getMediacentricOwnerForFilter = async (signal) => {
    try {
      let response = await this.get(
        API_ENDPOINTS.DROP_DOWN_NEW_MEDIACENTRIC_USER_LIST,
        {
          pageLimit: 0,
        },
        signal
      )
      if (response.status) {
        this.projectFiltersOwnersMediacentric = response.data
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      this.projectFiltersOwnersMediacentric = []
      return [false, undefined]
    }
  }

  @action.bound
  getCustomerOwnerForFilter = async () => {
    try {
      let response = await this.get(API_ENDPOINTS.CUSTOMER_USER_LIST, {})
      if (response.status) {
        this.projectFiltersOwnersCustomers = response.data
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      this.projectFiltersOwnersCustomers = []
      return [false, undefined]
    }
  }

  @action.bound
  getBillSettings = async () => {
    try {
      let response = await Promise.resolve({
        status: true,
        data: [
          {
            id: 'Fixed-Bid',
            name: 'Fixed-Bid',
          },
          {
            id: 'T&M',
            name: 'T&M',
          },
        ],
      })
      if (response.status) {
        this.billSettings = response.data
        return true
      } else {
        this.billSettings = []
        return false
      }
    } catch (err) {
      this.billSettings = []
      return false
    }
  }

  @action.bound
  addProject = async (values = {}) => {
    const {
      addressone,
      addresstwo,
      city,
      country,
      customer,
      manDaysDescription,
      description,
      duration,
      endDate,
      ownercustomer,
      ownermedia,
      projectname,
      projectAllTags,
      setbilling,
      startDate,
      state,
      zipcode,
    } = values

    let requestObject = {
      name: projectname,
      projectTagNames: projectAllTags || [],
      customerId: customer || null,
      ownerCustomer: ownercustomer || null,
      ownerMediaCentric: ownermedia,
      startDate,
      endDate,
      manDaysDescription: manDaysDescription,
      projectDetails: description,
      billingType: setbilling,
      duration: zeroWrapper(duration) ? zeroWrapper(duration) : undefined,
      addressLine1: addressone,
      addressLine2: addresstwo,
      city,
      country,
      state,
      projectStatusId: 1,
      zipcode: zipcode,
    }

    try {
      let response = await this.post(API_ENDPOINTS.ADD_PROJECTS, requestObject)
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  getProjectStatues = async (signal) => {
    try {
      let response = await this.get(API_ENDPOINTS.PROJECT_STATUES, {}, signal)
      if (response.status) {
        this.projectStatues = response.data
        return [true, response.data]
      } else {
        this.projectStatues = []
        return [false, undefined]
      }
    } catch (err) {
      this.projectStatues = []
      return [false, undefined]
    }
  }

  @action.bound
  exportAllProject = async (id) => {
    try {
      this.exportAllLoader = true
      let response = await this.post(API_ENDPOINTS.EXPORT_ALL_PROJECTS, {
        projectId: id,
      })
      if (response.status) {
        return [true, response.data]
      } else {
        return [false, undefined]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
      this.exportAllLoader = false
    }
  }

  @action.bound
  getProjectTags = async (signal) => {
    try {
      let response = await this.get(
        API_ENDPOINTS.PROJECT_TAGS,
        {
          pageLimit: 0,
        },
        signal
      )
      if (response.status) {
        this.projectTags = response.data.projectTags
        return [true, response.data]
      } else {
        this.projectTags = []
        return [false, undefined]
      }
    } catch (err) {
      this.projectTags = []
      return [false, undefined]
    }
  }

  @action.bound
  deleteProject = async (id) => {
    if (!id) {
      return
    }
    try {
      let response = await this.post(API_ENDPOINTS.DELETE_PROJECT, {
        id,
      })
      return response.status
    } catch (err) {
      return false
    }
  }

  @action.bound
  getProjectById = async (projectId, signal) => {
    try {
      this.projectByIdError = false
      let response = await this.get(
        API_ENDPOINTS.GET_PROJECT_BY_ID,
        {
          projectId,
        },
        signal
      )
      let responseOnsite = await this.get(
        API_ENDPOINTS.GET_ONSITE_LEAD,
        {},
        signal
      )
      if (response.status) {
        this.specificProject = response?.data
        this.onSitePermission = responseOnsite?.data
        this.isReportReadyToSend = this.specificProject?.sendReport
        this.isUserAssigned = response?.isUserAssigned
        return [true, response.data]
      } else {
        return [false, undefined]
      }
    } catch (err) {
      this.projectByIdError = true
      this.projectByIdErrorMessage = err?.message || TEXTS?.SOME_THING_WRONG
      return [false, undefined]
    }
  }

  @action.bound
  updateSpecificProjectLocally = async (projectId, updatedData) => {
    this.specificProject = updatedData
  }

  @action.bound
  updateProjectById = async (id, values = {}) => {
    const {
      customer,
      description,
      duration,
      manDaysDescription,
      endDate,
      ownercustomer,
      ownermedia,
      projectname,
      projectAllTags,
      setbilling,
      startDate,
      geolocation,
      addressone,
      addresstwo,
      city,
      country,
      state,
      zipcode,
    } = values
    try {
      let response = await this.post(API_ENDPOINTS.UPDATE_PROJECT, {
        id,
        name: projectname,
        projectTagNames: projectAllTags,
        customerId: customer,
        ownerCustomer: ownercustomer,
        ownerMediaCentric: ownermedia,
        startDate: startDate,
        endDate: endDate,
        manDaysDescription: manDaysDescription,
        projectDetails: description,
        billingType: setbilling,
        zipcode: zipcode,
        duration: zeroWrapper(duration) && zeroWrapper(duration),
        addressLine1: addressone,
        addressLine2: addresstwo,
        city: city,
        country: country,
        state: state,
      })
      if (response.status) {
        return [response.status, response.data]
      } else {
        return [false, undefined]
      }
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  updateProjectLocally = (id, values) => {
    this.projects = this.projects.map((project) => {
      if (project.id === id) {
        return {
          ...project,
          ...values,
        }
      } else {
        return project
      }
    })
  }

  @action.bound
  checkIfProjectExist = async (value) => {
    try {
      let respone = await this.post(API_ENDPOINTS?.CHECK_PROJECT_IS_EXIST, {
        name: value,
      })
      if (respone.status) {
        return [true, respone?.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  setBulkDownloadFile = async (isCheck, list = [], attachments, totalSpace) => {
    let newList = attachments.map((listItem) => {
      return listItem.id
    })

    if (isCheck) {
      this.setCheckSpaceBulk = this.setCheckSpaceBulk.concat(list)
      this.setCheckeFileList = this.setCheckeFileList.concat(newList)
      this.isBulkSpaceSelect = Boolean(
        totalSpace === this.setCheckSpaceBulk?.length ||
          1 < this.setCheckSpaceBulk?.length
      )
    } else {
      let attachmentToDelete = new Set(newList)
      let cleanAttachmentData = this.setCheckeFileList.filter(
        (listItem) => !attachmentToDelete.has(listItem)
      )
      this.setCheckeFileList = cleanAttachmentData
      let cleanSpaceList = this.setCheckSpaceBulk.filter(
        (listItem) => listItem !== list[0]
      )
      this.setCheckSpaceBulk = cleanSpaceList
      this.isBulkSpaceSelect = Boolean(1 <= this.setCheckSpaceBulk?.length)
    }
  }

  @action.bound
  setDownloadFile = async (list = [], totalFiles, id) => {
    this.setCheckeFileList = list
    this.isIndeterminate = !!list?.length && list?.length < totalFiles
    this.setCheckSpaceBulk = list?.length === totalFiles ? [id] : []
    this.isCheckAll = list?.length === totalFiles // we are using in project folder & attachment multi select
  }

  @action.bound
  downloadBulkFiles = async (list = {}, fileName, fileType) => {
    try {
      let options = {}
      if (fileType === FILE_SOURCE_STORE_TYPE.DIRECTORY) {
        options['directoryIds'] = list
        options['zipFileName'] = fileName
        let response = await this.post(
          API_ENDPOINTS.EXPORT_MULTIPLE_FOLDERS_TO_ZIP,
          options
        )
        if (response.status) {
          return [true, response.data]
        }
      } else {
        options['ids'] = list
        options['zipFileName'] = fileName
        let response = await this.post(
          API_ENDPOINTS.EXPORT_MULTIPLE_FILES_TO_ZIP,
          options
        )
        if (response.status) {
          return [true, response.data]
        }
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  setProjectAttachmentsFilter = (value = {}) => {
    this.projectAttachmentsFilter = value
  }

  @action.bound
  setSourceStorageType = (value = undefined) => {
    this.sourceStorageType = value
  }

  @action.bound
  setProjectAttachmentsSearchText = (value = '') => {
    this.projectAttachmentsSearchText = value
  }

  @action.bound
  setProjectAttachmentsCurrentPage = (page = DEFAULT_PAGE_START) => {
    this.projectAttachmentsCurrentPage = page
  }

  @action.bound
  getProjectAttachmentsFilter = () => {
    let temp = {}

    let keys = Object.keys(this.projectAttachmentsFilter || {})
    for (let filter of keys) {
      if (this.projectAttachmentsFilter[filter] !== undefined) {
        temp[filter] = this.projectAttachmentsFilter[filter]
      }
    }

    return temp
  }

  @action.bound
  getProjectAttachmentsById = async (
    projectId,
    parentDirectoryId,
    loadingStop,
    signal
  ) => {
    try {
      !loadingStop && (this.projectAttachmentsLoader = true)
      let options = this.getProjectAttachmentsFilter() || {}
      this.projectAttachmentsSearchText &&
        (options['search'] = this.projectAttachmentsSearchText)
      let response = await this.get(
        API_ENDPOINTS.GET_PROJECT_ATTACHMENTS,
        {
          projectId,
          parentDirectoryId,
          pageNo: Math.max(this.projectAttachmentsCurrentPage - 1, 0),
          ...options,
        },
        signal
      )
      if (response.status) {
        this.isCustomerFolderFlag = response.data?.isCustomerFolder
        this.projectAttachments = response.data.rows
        this.projectAttachmentsTotal = response.data.count || 0
        this.isUserAssignedInAttachment = response?.isUserAssigned
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.projectAttachmentsLoader = false
    }
  }

  @action.bound
  addProjectAttachments = async (values) => {
    try {
      this.addProjectAttachmentLoader = true
      let formDataValues = generateFormData(values)
      let response = await this.postWithFormData(
        API_ENDPOINTS.ADD_PROJECT_ATTACHMENTS,
        formDataValues
      )
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.addProjectAttachmentLoader = false
    }
  }

  @action.bound
  deleteAttachmentByProjectId = async (data = {}) => {
    try {
      let response = await this.post(API_ENDPOINTS.DELETE_ATTACHMENTS, data)
      if (response.status) {
        return [true, response.status]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  // Folder
  @action.bound
  moveAttachmentByFolderId = async (folderId = undefined, data = {}) => {
    try {
      let options = {}
      this.moveAttachmentbyIdLoader = true
      options['id'] = data?.id
      options['parentDirectoryId'] = folderId
      let response = await this.post(
        API_ENDPOINTS.MOVE_PROJECT_ATTACHMENTS,
        options
      )
      if (response.status) {
        return [true, response.status]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.moveAttachmentbyIdLoader = false
    }
  }

  @action.bound
  getProjectFoldersDropdownById = async (projectId, signal) => {
    try {
      let options = {}
      this.projectFoldersDropdownLoader = true
      let response = await this.get(
        API_ENDPOINTS.GET_PROJECT_ATTACHMENTS,
        {
          projectId,
          ...options,
        },
        signal
      )
      if (response.status) {
        this.projectFoldersDropdownList = response.data.rows
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.projectFoldersDropdownLoader = false
    }
  }

  @action.bound
  setProjectFoldersSearchText = (value = '') => {
    this.projectFoldersSearchText = value
  }

  @action.bound
  setProjectFoldersCurrentPage = (page = DEFAULT_PAGE_START) => {
    this.projectFoldersCurrentPage = page
  }

  @action.bound
  getProjectFoldersById = async (projectId, loadingStop, signal) => {
    try {
      loadingStop
        ? (this.addProjectAttachmentLoader = true)
        : (this.projectFoldersLoader = true)
      let options = {}
      this.projectFoldersSearchText &&
        (options['search'] = this.projectFoldersSearchText)
      let response = await this.get(
        API_ENDPOINTS.GET_PROJECT_ATTACHMENTS,
        {
          projectId,
          pageNo: Math.max(this.projectFoldersCurrentPage - 1, 0),
          ...options,
        },
        signal
      )
      if (response.status) {
        this.projectFoldersList = response.data.rows
        this.projectFoldersTotal = response.data.count || 0
        this.isUserAssignedInProjectFolder = response?.isUserAssigned
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.projectFoldersLoader = false
      this.addProjectAttachmentLoader = false
    }
  }

  @action.bound
  addProjectFolderByProjectId = async (values) => {
    try {
      let response = await this.post(
        API_ENDPOINTS.ADD_PROJECT_DIRECTORY,
        values
      )
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  addProjectFolderByProjectIdLocally = async (values) => {
    this.projectFoldersList = [values, ...this.projectFoldersList]
    if (this.projectFoldersList.length > 10) {
      this.projectFoldersList.pop()
    }
    this.projectFoldersTotal++
  }

  @action.bound
  updateProjectFolderByProjectId = async (values) => {
    try {
      this.addProjectFolderLoader = true
      let response = await this.post(
        API_ENDPOINTS.UPDATE_PROJECT_DIRECTORY,
        values
      )
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.addProjectFolderLoader = false
    }
  }

  @action.bound
  updateProjectFolderByProjectIdLocally = async (id, values) => {
    this.projectFoldersList = (this.projectFoldersList || []).map((folder) => {
      if (folder.id === id) {
        return values
      } else {
        return folder
      }
    })
  }

  @action.bound
  deleteFolderByProjectId = async (data = {}) => {
    try {
      this.addProjectFolderLoader = true
      let response = await this.post(API_ENDPOINTS.DELETE_PROJECT_FOLDERS, data)
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.addProjectFolderLoader = false
    }
  }

  @action.bound
  resetProjectAttachmentsFilterForm = () => {
    this.projectAttachmentsFilter = {}
  }
  // End Project Attachments

  @action.bound
  setProjectDailyReportAttachmentsFilter = (value = {}) => {
    this.projectDailyReportAttachmentsFilter = value
  }

  setDateChoiceForProjectDailyReport = (value = undefined) => {
    this.projectDailyReportAttachmentsDateChoice = value
  }

  @action.bound
  setProjectDailyReportAttachmentsSearchText = (value = '') => {
    this.projectDailyReportAttachmentsSearchText = value
  }

  @action.bound
  setProjectDailyReportAttachmentsCurrentPage = (page = DEFAULT_PAGE_START) => {
    this.projectDailyReportAttachmentsCurrentPage = page
  }

  @action.bound
  getProjectDailyReportAttachmentFilter = () => {
    let temp = {}

    let keys = Object.keys(this.projectDailyReportAttachmentsFilter || {})
    for (let filter of keys) {
      if (this.projectDailyReportAttachmentsFilter[filter] !== undefined) {
        temp[filter] = this.projectDailyReportAttachmentsFilter[filter]
      }
    }
    let { start, end } = getUtcUnixDate(
      this.projectDailyReportAttachmentsDateChoice,
      {
        start: temp?.startDate,
        end: temp?.endDate,
      }
    )
    start ? (temp['startDate'] = start) : delete temp['startDate']
    end ? (temp['endDate'] = end) : delete temp['endDate']

    delete temp['choice']

    return temp
  }

  @action.bound
  getProjectDailyReportAttachmentById = async (projectId, signal) => {
    try {
      this.projectDailyReportAttachmentsLoader = true
      this.projectDailyReportError = false
      let options = this.getProjectDailyReportAttachmentFilter() || {}
      this.projectDailyReportAttachmentsSearchText &&
        (options['search'] = this.projectDailyReportAttachmentsSearchText)
      let response = await this.get(
        API_ENDPOINTS.GET_PROJECT_DAILY_REPORT_ATTACHMENTS,
        {
          projectId,
          pageNo: Math.max(
            this.projectDailyReportAttachmentsCurrentPage - 1,
            0
          ),
          ...options,
        },
        signal
      )
      if (response.status) {
        this.projectDailyReportAttachments = response.data.dailyReports
        this.projectDailyReportAttachmentsTotal = response.data.total || 0
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      this.projectDailyReportError = true
      this.projectDailyReportErrorMessage =
        err?.message || TEXTS?.SOME_THING_WRONG
      return [false, undefined]
    } finally {
      this.projectDailyReportAttachmentsLoader = false
    }
  }

  @action.bound
  sendProjectDailyReportToMail = async (values) => {
    try {
      this.sendProjectDailyReportAttachmentLoader = true
      let response = await this.post(
        API_ENDPOINTS.SEND_DAILY_REPORT_ATTACHMENTS_TO_MAIL,
        {
          ...values,
        }
      )
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.sendProjectDailyReportAttachmentLoader = false
    }
  }

  @action.bound
  resetProjectDailyReportAttachmentsFilterForm = () => {
    this.projectDailyReportAttachmentsFilter = {}
  }
  // End Project Daily Report

  @action.bound
  getProjectStatusTaskCount = async (projectId, signal) => {
    try {
      let response = await this.get(
        API_ENDPOINTS.TASK_STATUS_COUNT,
        {
          projectId,
        },
        signal
      )
      if (response.status) {
        this.projectTaskStatusCount = response.data || {}
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  getProjectStatusByGroup = async (projectId, signal) => {
    try {
      let response = await this.get(
        API_ENDPOINTS.TASK_GROUP_DATA,
        {
          projectId,
        },
        signal
      )
      if (response.status) {
        this.projectTaskStatusCountByGroup = response.data || {}
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  getProjectFeedbackQuestions = async (projectId, loader = true) => {
    try {
      if (loader) {
        this.projectFeedbackLoader = true
      }

      let response = await this.get(API_ENDPOINTS.PROJECT_FEEDBACK, {
        projectId,
      })
      if (response.status) {
        this.projectFeedback = response.data?.feedbackQuestions || []
        this.isUserAssignedInFeedback = response?.isUserAssigned
        return [true, response.data?.feedbackQuestions]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      if (loader) {
        this.projectFeedbackLoader = false
      }
    }
  }

  @action.bound
  submitProjectFeedback = async (projectId, values) => {
    try {
      this.projectFeedbackSaveLoader = true
      let response = await this.post(API_ENDPOINTS.ADD_FEEDBACK, {
        projectId,
        ...values,
      })
      await this.getProjectFeedbackQuestions(projectId, false)
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.projectFeedbackSaveLoader = false
    }
  }

  @action.bound
  getAllProjectsForDropdown = async (signal) => {
    try {
      this.allProjectsForDropdownLoader = true

      let response = await this.post(
        API_ENDPOINTS.ALL_PROJECTS_FOR_DROPDOWN,
        {
          isDeleted: false,
          isDraft: false,
        },
        signal
      )
      if (response.status) {
        this.allProjectsForDropdown = response.data.projects || []
        return true
      } else {
        return false
      }
    } catch (err) {
      return false
    } finally {
      this.allProjectsForDropdownLoader = false
    }
  }

  @action.bound
  importProjectsFromFile = async (values) => {
    try {
      this.importProjectFromFileLoader = true
      let formDataValues = generateFormData(values)
      let response = await this.postWithFormData(
        API_ENDPOINTS.IMPORT_PROJECT_FROM_FILE,
        formDataValues
      )
      if (response.status) {
        this.importProjects = response.data || []
        this.importProjectsFailures =
          {
            headerMessage: response?.message || '',
            failedErrors: response.data?.failures || [],
            fileUpload: response.status,
            isError: true,
          } || []
        return [true, response.data]
      } else {
        return [false, undefined]
      }
    } catch (err) {
      if (err?.error?.statusCode === ERROR_CODE?.MENUAL_CODE) {
        this.importProjectsFailures =
          {
            headerMessage: err?.message,
            failedErrors: null,
            fileUpload: false,
            isError: true,
          } || []
        return [false, undefined]
      } else {
        this.importProjectsFailures =
          {
            headerMessage: err?.message,
            failedErrors: err?.error,
            fileUpload: false,
            isError: true,
          } || []
        return [false, undefined]
      }
    } finally {
      this.importProjectFromFileLoader = false
    }
  }

  @action.bound
  importProjectsFromFileReset = async () => {
    this.importProjects = []
    this.importProjectsFailures = []
  }

  // Draft Tabs

  @action.bound
  setOrderingDraft = (value = undefined) => {
    this.orderingDraft = value
  }

  @action.bound
  setOrderingDraftBy = (value = undefined) => {
    if (value === 'projectname') {
      value = 'name'
    }
    this.orderingDraftBy = value
  }

  @action.bound
  setDraftProjectsFilters = (value = {}) => {
    this.draftProjectsFilters = value
  }

  @action.bound
  setDraftProjectsSearchText = (value = '') => {
    this.draftProjectsSearchText = value
  }

  @action.bound
  setDraftProjectsPageNo = (page = DEFAULT_PAGE_START) => {
    this.draftProjectsPageNo = page
  }

  @action.bound
  setDateChoiceForDraftProjects = (value = undefined) => {
    this.draftProjectsDateChoice = value
  }

  @action.bound
  getFiltersForDraftProjects = () => {
    let temp = {}
    this.draftProjectsSearchText &&
      (temp['search'] = this.draftProjectsSearchText)
    let keys = Object.keys(this.draftProjectsFilters || {})
    for (let filter of keys) {
      if (this.draftProjectsFilters[filter] !== undefined) {
        temp[filter] = this.draftProjectsFilters[filter]
      }
    }
    let { start, end } = getUtcUnixDate(this.draftProjectsDateChoice, {
      start: temp?.startDate,
      end: temp?.endDate,
    })

    start ? (temp['startDate'] = start) : delete temp['startDate']
    end ? (temp['endDate'] = end) : delete temp['endDate']

    delete temp['choice']
    if (this.orderingDraft) {
      temp['ordering'] = this.orderingDraft
      temp['orderBy'] = this.orderingDraftBy
    }
    return temp
  }

  @action.bound
  getAllDraftProjectsExport = async ({ exportFileType = 'csv' } = {}) => {
    try {
      let options = this.getFiltersForDraftProjects()
      options['exportFileType'] = exportFileType
      let response = await this.post(API_ENDPOINTS.EXPORT_PROJECTS, {
        isDraft: true,
        isDeleted: false,
        pageLimit: 0,
        ...options,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  getDraftProjects = async () => {
    try {
      this.draftProjectsLoader = true
      let filters = this.getFiltersForDraftProjects()
      let response = await this.post(API_ENDPOINTS.GET_ALL_PROJECTS, {
        ...filters,
        pageNo: Math.max(this.draftProjectsPageNo - 1, 0),
        pageLimit: DEFAULT_PER_PAGE_RECORD,
        isDraft: true,
        isDeleted: false,
      })
      if (response.status) {
        this.draftProjectsTotal = response?.data?.total || 0
        this.draftProjects = response?.data?.projects || []
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      console.log(err, 66)
      return [false, undefined]
    } finally {
      this.draftProjectsLoader = false
    }
  }

  // End Draft
  // Completed

  @action.bound
  updateCompletedProjectLocally = (id, values) => {
    this.completedProjects = this.completedProjects.map((project) => {
      if (project.id === id) {
        return {
          ...project,
          ...values,
        }
      } else {
        return project
      }
    })
  }

  @action.bound
  setCompletedProjectsFilters = (value = {}) => {
    this.completedProjectsFilters = value
  }

  @action.bound
  setCompletedProjectsSearchText = (value = '') => {
    this.completedProjectsSearchText = value
  }

  setCompletedProjectsPageNo = (page = DEFAULT_PAGE_START) => {
    this.completedProjectsPageNo = page
  }

  setDateChoiceForCompletedProjects = (value = undefined) => {
    this.completedProjectsDateChoice = value
  }

  getFiltersForCompletedProjects = () => {
    let temp = {}
    this.completedProjectsSearchText &&
      (temp['search'] = this.completedProjectsSearchText)
    let keys = Object.keys(this.completedProjectsFilters || {})
    for (let filter of keys) {
      if (this.completedProjectsFilters[filter] !== undefined) {
        temp[filter] = this.completedProjectsFilters[filter]
      }
    }
    let { start, end } = getUtcUnixDate(this.completedProjectsDateChoice, {
      start: temp?.startDate,
      end: temp?.endDate,
    })

    start ? (temp['startDate'] = start) : delete temp['startDate']
    end ? (temp['endDate'] = end) : delete temp['endDate']

    delete temp['choice']
    if (this.ordering) {
      temp['ordering'] = this.ordering
      temp['orderBy'] = this.orderingBy
    }

    return temp
  }

  getAllCompletedProjectsExport = async ({ exportFileType = 'csv' } = {}) => {
    try {
      let options = this.getFiltersForCompletedProjects()
      options['exportFileType'] = exportFileType
      let response = await this.post(API_ENDPOINTS.EXPORT_PROJECTS, {
        isDraft: false,
        isDeleted: false,
        projectStatusId: [4],
        pageLimit: 0,
        ...options,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  getCompletedProjects = async () => {
    try {
      this.completedProjectsLoader = true
      let filters = this.getFiltersForCompletedProjects()
      let response = await this.post(API_ENDPOINTS.GET_ALL_PROJECTS, {
        ...filters,
        pageNo: Math.max(this.completedProjectsPageNo - 1, 0),
        pageLimit: DEFAULT_PER_PAGE_RECORD,
        isDraft: false,
        isDeleted: false,
        projectStatusId: [4],
      })
      if (response.status) {
        this.completedProjectsTotal = response?.data?.total || 0
        this.completedProjects = response?.data?.projects || []
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      console.log(err, 66)
      return [false, undefined]
    } finally {
      this.completedProjectsLoader = false
    }
  }
  // End completed

  // Cancelled

  // @action.bound
  // updateCompletedProjectLocally = (id, values) => {
  //   this.completedProjects = this.completedProjects.map((project) => {
  //     if (project.id === id) {
  //       return {
  //         ...project,
  //         ...values,
  //       }
  //     } else {
  //       return project
  //     }
  //   })
  // }
  @action.bound
  setCancelledProjectsFilters = (value = {}) => {
    this.cancelledProjectsFilters = value
  }

  @action.bound
  setCancelledProjectsSearchText = (value = '') => {
    this.cancelledProjectsSearchText = value
  }

  setCancelledProjectsPageNo = (page = DEFAULT_PAGE_START) => {
    this.cancelledProjectsPageNo = page
  }

  setDateChoiceForCancelledProjects = (value = undefined) => {
    this.cancelledProjectsDateChoice = value
  }

  getFiltersForCancelledProjects = () => {
    let temp = {}
    this.cancelledProjectsSearchText &&
      (temp['search'] = this.cancelledProjectsSearchText)
    let keys = Object.keys(this.cancelledProjectsFilters || {})
    for (let filter of keys) {
      if (this.cancelledProjectsFilters[filter] !== undefined) {
        temp[filter] = this.cancelledProjectsFilters[filter]
      }
    }
    let { start, end } = getUtcUnixDate(this.cancelledProjectsDateChoice, {
      start: temp?.startDate,
      end: temp?.endDate,
    })

    start ? (temp['startDate'] = start) : delete temp['startDate']
    end ? (temp['endDate'] = end) : delete temp['endDate']

    delete temp['choice']
    if (this.ordering) {
      temp['ordering'] = this.ordering
      temp['orderBy'] = this.orderingBy
    }

    return temp
  }

  getAllCancelledProjectsExport = async ({ exportFileType = 'csv' } = {}) => {
    try {
      let options = this.getFiltersForCancelledProjects()
      options['exportFileType'] = exportFileType
      let response = await this.post(API_ENDPOINTS.EXPORT_PROJECTS, {
        isDraft: false,
        isDeleted: false,
        projectStatusId: [5],
        pageLimit: 0,
        ...options,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  getCancelledProjects = async () => {
    try {
      this.cancelledProjectsLoader = true
      let filters = this.getFiltersForCancelledProjects()
      let response = await this.post(API_ENDPOINTS.GET_ALL_PROJECTS, {
        ...filters,
        pageNo: Math.max(this.cancelledProjectsPageNo - 1, 0),
        pageLimit: DEFAULT_PER_PAGE_RECORD,
        isDraft: false,
        isDeleted: false,
        projectStatusId: [5],
      })
      if (response.status) {
        this.cancelledProjectsTotal = response?.data?.total || 0
        this.cancelledProjects = response?.data?.projects || []
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      console.log(err, 66)
      return [false, undefined]
    } finally {
      this.cancelledProjectsLoader = false
    }
  }
  // End Cancelled

  // Dashboard project
  @action.bound
  updateDashboardProjectLocally = (id, values) => {
    this.dashboardProjects = this.dashboardProjects.map((project) => {
      if (project.id === id) {
        return {
          ...project,
          ...values,
        }
      } else {
        return project
      }
    })
  }

  @action.bound
  deleteDashboardProjectProject = async (id) => {
    if (!id) {
      return
    }
    try {
      let response = await this.post(API_ENDPOINTS.DELETE_PROJECT, {
        id,
      })
      return response.status
    } catch (err) {
      return false
    }
  }

  @action.bound
  setStatusForDashboardProject = async (status) => {
    this.dashboardProjectStatus = parseInt(status) || undefined
  }

  @action.bound
  setDashboardProjectsByMonth = (value = {}) => {
    this.dashboardProjectsByMonth = value
  }

  @action.bound
  setDashboardProjectsFilters = (value = {}) => {
    this.dashboardProjectsFilters = value
  }

  @action.bound
  setDashboardProjectsSearchText = (value = '') => {
    this.dashboardProjectsSearchText = value
  }

  setDashboardProjectsPageNo = (page = DEFAULT_PAGE_START) => {
    this.dashboardProjectsPageNo = page
  }

  setDateChoiceForDashboardProjects = (value = undefined) => {
    this.dashboardProjectsDateChoice = value
  }

  getFiltersForDashboardProjects = () => {
    let temp = {}
    this.dashboardProjectsByMonth &&
      Object.assign(temp, this.dashboardProjectsByMonth)
    this.dashboardProjectsSearchText &&
      (temp['search'] = this.dashboardProjectsSearchText)
    let keys = Object.keys(this.dashboardProjectsFilters || {})
    for (let filter of keys) {
      if (this.dashboardProjectsFilters[filter] !== undefined) {
        temp[filter] = this.dashboardProjectsFilters[filter]
      }
    }

    let { start, end } = getUtcUnixDate(this.dashboardProjectsDateChoice, {
      start: temp?.startDate,
      end: temp?.endDate,
    })

    start ? (temp['startDate'] = start) : delete temp['startDate']
    end ? (temp['endDate'] = end) : delete temp['endDate']

    delete temp['choice']
    if (this.ordering) {
      temp['ordering'] = this.ordering
      temp['orderBy'] = this.orderingBy
    }
    this.dashboardProjectStatus &&
      (temp['projectStatusId'] = [this.dashboardProjectStatus])

    return temp
  }

  getAllDashboardProjectsExport = async ({ exportFileType = 'csv' } = {}) => {
    try {
      let options = this.getFiltersForDashboardProjects()
      options['exportFileType'] = exportFileType
      let response = await this.post(API_ENDPOINTS.EXPORT_PROJECTS, {
        isDraft: false,
        isDeleted: false,
        pageLimit: 0,
        ...options,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  getDashboardProjects = async () => {
    try {
      this.dashboardProjectsLoader = true
      let filters = this.getFiltersForDashboardProjects()
      let response = await this.post(API_ENDPOINTS.GET_ALL_PROJECTS, {
        ...filters,
        pageNo: Math.max(this.dashboardProjectsPageNo - 1, 0),
        pageLimit: DEFAULT_PER_PAGE_RECORD,
        isDraft: false,
        isDeleted: false,
      })
      if (response.status) {
        this.dashboardProjectsTotal = response?.data?.total || 0
        this.dashboardProjects = response?.data?.projects || []
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      console.log(err, 66)
      return [false, undefined]
    } finally {
      this.dashboardProjectsLoader = false
    }
  }

  @action.bound
  resetDashboardProject = async () => {
    this.dashboardProjectsPageNo = DEFAULT_PAGE_START
  }

  /// End Dashboard project

  @action.bound
  getProjectResourceAllocations = async (projectId, signal) => {
    try {
      this.projectResourceAllocationsLoader = true
      let response = await this.get(
        API_ENDPOINTS.PROJECT_RESOURCES,
        {
          projectId,
        },
        signal
      )
      if (response.status) {
        this.projectResourceAllocations = response.data
        return [true, this.projectResourceAllocations]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.projectResourceAllocationsLoader = false
    }
  }

  @action.bound
  getProjectInstallationImages = async (projectId, signal) => {
    try {
      this.projectInstallationImagesLoader = true
      let response = await this.get(
        API_ENDPOINTS.PROJECT_INSTALLATION_IMAGES,
        {
          projectId,
          pageLimit: DEFAULT_PER_PAGE_RECORD,
        },
        signal
      )
      if (response.status) {
        this.projectInstallationImages = response.data.projectTaskImages
        this.projectInstallationImagesTotal = response.data.total || 0

        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.projectInstallationImagesLoader = false
    }
  }

  @action.bound
  getProjectActionItemInstallationImages = async (projectId, signal) => {
    try {
      this.projectActionItemInstallationImagesLoader = true
      let response = await this.get(
        API_ENDPOINTS.PROJECT_ACTION_ITEM_INSTALLATION_IMAGES,
        {
          projectId,
          pageLimit: DEFAULT_PER_PAGE_RECORD,
        },
        signal
      )
      if (response.status) {
        this.projectActionItemInstallationImages =
          response.data.projectActionImages
        this.projectActionItemInstallationImagesTotal = response.data.total || 0

        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.projectActionItemInstallationImagesLoader = false
    }
  }

  @action.bound
  getShortDetailsOfProject = async (projectId, signal) => {
    try {
      let response = await this.get(
        API_ENDPOINTS.PROJECT_SHORT_DETAILS,
        {
          projectId,
        },
        signal
      )
      if (response.status) {
        this.projectShortDetails = response.data || {}
        this.isAssignedUser = response.isUserAssigned
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  changeProjectStatus = async (id, values) => {
    try {
      this.projectStatusLoader = true
      let response = await this.post(API_ENDPOINTS.UPDATE_PROJECT, {
        id,
        ...values,
      })
      if (response.status) {
        this.updateSpecificProjectLocally(id, response.data)
        return [true, undefined]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
      this.projectStatusLoader = false
    }
  }

  @action.bound
  downloadSnapshotReport = async (projectId) => {
    try {
      this.downloadSnapshotReportLoader = true
      let response = await this.post(
        API_ENDPOINTS.PROJECT_DASHBOARD_SNAPSHOT_REPORT_EXPORT,
        { projectId }
      )
      if (response.status) {
        return [true, response.data]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
      this.downloadSnapshotReportLoader = false
    }
  }

  @action.bound
  resetFilterForm = () => {
    this.pfSelectedDateChoice = undefined
    this.pfAllFilters = {}
  }

  @action.bound
  resetStore = () => {
    this.isReportReadyToSend = false
    this.isUserAssigned = false
    this.isAssignedUser = false
    this.totalProjects = 0
    this.dashboardProjectStatus = undefined
    this.projects = []
    this.projectsLoader = false
    this.projectsSearchText = ''
    this.projectsPageNo = DEFAULT_PAGE_START
    this.projectsPageLimit = DEFAULT_PER_PAGE_RECORD
    this.projectFiltersGetLoader = false
    this.projectFiltersCustomers = []
    this.projectsFiltersOnSiteLead = []
    this.projectFiltersOwnersMediacentric = []
    this.projectFiltersOwnersCustomers = []
    this.pfAllFilters = {}
    this.pfSelectedDateChoice = undefined
    this.billSettings = []
    this.projectStatues = []
    this.projectTags = []
    this.projectTaskStatusCount = {}
    this.projectTaskStatusCountByGroup = {}
    this.specificProject = {}
    this.onSitePermission = {}
    this.projectByIdError = false
    this.projectByIdErrorMessage = TEXTS?.SOME_THING_WRONG

    this.projectFoldersDropdownLoader = false
    this.projectFoldersDropdownList = []
    this.sourceStorageType = undefined
    this.projectFoldersSearchText = ''
    this.projectFoldersLoader = false
    this.projectFoldersCurrentPage = DEFAULT_PAGE_START
    this.projectFoldersList = []
    this.isUserAssignedInProjectFolder = false
    this.projectFoldersTotal = 0
    this.addProjectFolderLoader = false
    this.moveAttachmentbyIdLoader = false
    this.projectAttachmentsSearchText = ''
    this.projectAttachments = []
    this.projectAttachmentsLoader = false
    this.projectAttachmentsTotal = 0
    this.projectAttachmentsCurrentPage = DEFAULT_PAGE_START
    this.projectAttachmentsFilter = {}
    this.addProjectAttachmentLoader = false
    this.projectDailyReportAttachmentsFilter = {}
    this.projectDailyReportAttachmentsDateChoice = undefined
    this.projectDailyReportAttachmentsSearchText = ''
    this.projectDailyReportAttachmentsCurrentPage = DEFAULT_PAGE_START
    this.projectDailyReportAttachmentsLoader = false
    this.projectDailyReportAttachments = []
    this.projectDailyReportAttachmentsTotal = 0
    this.sendProjectDailyReportAttachmentLoader = false
    this.projectDailyReportError = false
    this.projectDailyReportErrorMessage = TEXTS?.SOME_THING_WRONG

    this.projectFeedback = []
    this.projectFeedbackLoader = false
    this.projectFeedbackSaveLoader = false
    this.ordering = undefined
    this.orderingBy = undefined
    this.allProjectsForDropdown = []
    this.allProjectsForDropdownLoader = false
    this.draftProjectsLoader = false
    this.draftProjectsPageNo = DEFAULT_PAGE_START
    this.draftProjectsDateChoice = undefined
    this.draftProjectsSearchText = ''
    this.draftProjectsTotal = 0
    this.orderingDraft = undefined
    this.orderingDraftBy = undefined
    this.draftProjectsFilters = {}
    this.draftProjects = []

    this.completedProjectsLoader = false
    this.completedProjectsPageNo = DEFAULT_PAGE_START
    this.completedProjectsDateChoice = undefined
    this.completedProjectsSearchText = ''
    this.completedProjectsTotal = 0
    this.completedProjectsFilters = {}
    this.completedProjects = []

    this.cancelledProjectsLoader = false
    this.cancelledProjectsPageNo = DEFAULT_PAGE_START
    this.cancelledProjectsDateChoice = undefined
    this.cancelledProjectsSearchText = ''
    this.cancelledProjectsTotal = 0
    this.cancelledProjectsFilters = {}
    this.cancelledProjects = []

    this.dashboardProjectsLoader = false
    this.dashboardProjectsPageNo = DEFAULT_PAGE_START
    this.dashboardProjectsDateChoice = undefined
    this.dashboardProjectsSearchText = ''
    this.dashboardProjectsTotal = 0
    this.dashboardProjectsByMonth = {}
    this.dashboardProjectsFilters = {}
    this.dashboardProjects = []

    this.projectResourceAllocations = {}
    this.projectResourceAllocationsLoader = false
    this.projectInstallationImages = []
    this.projectInstallationImagesTotal = 0
    this.projectInstallationImagesLoader = false
    this.projectActionItemInstallationImages = []
    this.projectActionItemInstallationImagesTotal = 0
    this.projectActionItemInstallationImagesLoader = false
    this.projectShortDetails = {}
    this.projectStatusLoader = false
    this.setCheckSpaceBulk = []
    this.setCheckeFileList = []
    this.isCheckAll = false
    this.isBulkSpaceSelect = false
    this.isIndeterminate = false

    this.importProjects = []
    this.importProjectsFailures = []
    this.importProjectFromFileLoader = false
    this.downloadSnapshotReportLoader = false
    this.exportAllLoader = false
    this.isCustomerFolderFlag = false
  }
}
